import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57708d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pb-4 pl-4 text-gray-400"
}
const _hoisted_2 = ["onClick"]

import { ref, inject, onMounted } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AppSimpleDatatable',
  props: {
		options: {
			type: Object,
			default: {
				columns: [],
				data: [],
				isLoading: false,
			},
		},
		heightTable: {
			type: String,
			default: "calc(100vh - 20rem)",
		},
		title: {
			type: String,
			default: "",
		},
		styleTable: {
			type: String,
			default: "w-full",
		},
		styleHeader: {
			type: String,
			default: "custum-bg-opacity-40",
		},
		styleRow: {
			type: String,
			default: "rounded-xl",
		},
		emptyTagStyle: {
			type: String,
			default: "",
		},
		dynamicWidth: {
			type: Boolean,
			default: false,
		},
		moreactions: {
			type: Object,
			default: {
				status: {
					type: Boolean,
					default: false,
				},
				style: {
					type: String,
					default: "w-[8%]",
				},
				action_1: {
					type: Object,
					default: {
						status: false,
						icon: "/media/icons/more-actions-icons.svg",
						style: {
							type: String,
							default: "w-6 h-6",
						},
					},
				},
				action_2: {
					type: Object,
					default: {
						status: false,
						icon: "/media/icons/more-actions-icons.svg",
						style: {
							type: String,
							default: "w-6 h-6",
						},
					},
				},
				dot_action: {
					type: Object,
					default: {
						status: true,
						options: [],
						onClick: {
							Type: Function,
							default: (data: any) => {
								//
							},
						},
					},
				},
			},
		},
	},
  setup(__props) {

	const widthColumns = ref("w-10");
	const height = ref("h-10");

	/**
	 * Varialbles
	 */
	const props = __props;
	
	/**
	 * App Lifecycle
	 */
	onMounted(() => {
		const totalColumns = props.options.columns.length;
		widthColumns.value = totalColumns > 0 ? 100 / totalColumns + "%" : "10";
		// console.log("props.options: ", props.moreactions.action_2.status);
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_MoreActionsTag = _resolveComponent("MoreActionsTag")!
  const _component_EmptyTag = _resolveComponent("EmptyTag")!
  const _component_AppDatatableSkeleton = _resolveComponent("AppDatatableSkeleton")!
  const _component_SkeletonLoader = _resolveComponent("SkeletonLoader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			__props.styleTable,
			{ 'flex flex-col text-white': true },
		])
  }, [
    (__props.title != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
				__props.styleHeader,
				{ 'flex flex-row justify-between p-2  border-b-1 border-white  rounded-xl mr-2': true },
			])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.columns, (column, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([{ 'text-white font-medium text-sm pl-2': true }]),
          style: _normalizeStyle({ width: __props.dynamicWidth ? column.width : widthColumns.value }),
          key: index
        }, _toDisplayString(column.label), 5))
      }), 128)),
      (__props.moreactions?.status ?? false)
        ? _renderSlot(_ctx.$slots, "moreactions", { key: 0 }, () => [
            _createElementVNode("span", {
              class: _normalizeClass([__props.moreactions.style ?? 'w-[8%]', { 'mr-4 flex justify-end': true }])
            }, "Actions", 2)
          ])
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: "flex flex-col overflow-y-auto custumScroll",
      style: _normalizeStyle({ height: __props.heightTable })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.data, (row, indexRow) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([
				__props.styleRow,
					{
						'items-center border-b border-opacity-10   mmr-2': true,
						'flex flex-row  py-2 px-2 justify-between custum-bg-opacity-20': true,
						'cursor-pointer': true,
					},
				]),
          key: indexRow,
          onClick: ($event: any) => (_ctx.$emit('on-selected', row))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.columns, (column, indexColumn) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([column.style, { 'text-gray-400 pl-2 pr-4': true }]),
              style: _normalizeStyle({ width: __props.dynamicWidth ? column.width : widthColumns.value }),
              key: indexColumn
            }, [
              _renderSlot(_ctx.$slots, column.name, { data: row }, () => [
                _createTextVNode(_toDisplayString(row[column.name]), 1)
              ])
            ], 6))
          }), 128)),
          (__props.moreactions?.status ?? false)
            ? _renderSlot(_ctx.$slots, "more-actions", { key: 0 }, () => [
                _createElementVNode("div", {
                  class: _normalizeClass([
							__props.moreactions.style ?? 'w-[8%]',
							__props.moreactions.stylerow ?? '',
							{ 'flex justify-end ': true },
						])
                }, [
                  (__props.moreactions.action_1.status ?? false)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 0,
                        src: __props.moreactions.action_1.icon ?? '/media/icons/more-actions-icons.svg',
                        css: __props.moreactions.action_1.style ?? 'w-6 h-6',
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('on-action-1', row)), ["stop"])
                      }, null, 8, ["src", "css", "onClick"]))
                    : _createCommentVNode("", true),
                  (__props.moreactions.action_2.status ?? false)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 1,
                        src: __props.moreactions.action_2.icon ?? '/media/icons/more-actions-icons.svg',
                        css: __props.moreactions.action_2.style ?? 'w-6 h-6',
                        onClick: _withModifiers(($event: any) => (_ctx.$emit('on-action-2', row)), ["stop"])
                      }, null, 8, ["src", "css", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_MoreActionsTag, {
                    options: __props.moreactions.dot_action.options,
                    onClick: (data, clickedOptionName,  clickedOptionSubName) => __props.moreactions.dot_action.onClick(data, clickedOptionName),
                    styleSubMenu: "left-[-125px]",
                    data: row
                  }, null, 8, ["options", "onClick", "data"])
                ], 2)
              ])
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128)),
      (__props.options.data.length == 0 && !__props.options.isLoading)
        ? (_openBlock(), _createBlock(_component_EmptyTag, {
            key: 0,
            styleAsset: __props.emptyTagStyle,
            height: __props.heightTable
          }, null, 8, ["styleAsset", "height"]))
        : _createCommentVNode("", true),
      (__props.options.isLoading)
        ? (_openBlock(), _createBlock(_component_SkeletonLoader, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_AppDatatableSkeleton, { stats: 6 })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 4)
  ], 2))
}
}

})